<template lang="pug">
  div
    v-row
      v-col(sm="6")
        TextBox(
          :value.sync="model.name"
          :label="$t('form.rewardTemplate.name')",
          :error-messages="errors.name",
          @update:value="clearError('name')",
        )
      v-col(sm="6")
        NumberBox(
          :value.sync="model.points"
          :label="$t('form.rewardTemplate.points')",
          :error-messages="errors.points",
          @update:value="clearError('points')",
        )
      v-col(sm="6")
        Datepicker(
          :label="$t('form.rewardTemplate.start')",
          :value.sync="start",
          :error-messages="errors.start",
          @update:value="clearError('start')",
        )
      v-col(sm="6")
        Datepicker(
          :label="$t('form.rewardTemplate.end')",
          :value.sync="end",
          :error-messages="errors.end",
          @update:value="clearError('end')",
        )

      v-col(sm="12")
        ShopPicker(
          :value.sync="shops",
          :error-messages="errors.shops",
          @update:value="clearError('shops')",
        )

    TextBox(
      :value.sync="model.description"
      :label="$t('form.rewardTemplate.description')",
      :error-messages="errors.description",
      @update:value="clearError('description')",
    )

    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
        color="primary",
        :disabled="hasError || !valid",
        :ripple="false",
        :loading="isLoading",
        @click="submit",
      ) {{ $t(`form.rewardTemplate.${ isEdit ? 'update': 'create'}`) }}
</template>

<script>
import { mergeRight } from 'ramda';
import { formHelper } from '@/config/mixins';
import { formatDate, tzUTC } from '@/utils/helper';
import Datepicker from '@/components/forms/inputs/Datepicker.vue';
import ShopPicker from '@/components/forms/inputs/ShopPicker.vue';

export default {
  components: {
    Datepicker,
    ShopPicker,
  },

  mixins: [formHelper],

  data: () => ({
    shops: [],
    start: null,
    end: null,
  }),

  created() {
    if (this.isEdit && this.model.end.length === 24) {
      this.start = formatDate(this.model.start, 'dd/MM/yyyy');
      this.end = formatDate(this.model.end, 'dd/MM/yyyy');
    } else {
      this.start = this.model.start;
      this.end = this.model.end;
    }
    this.shops = this.model.shops;
  },

  methods: {
    submit() {
      if (this.validate()) {
        const action = this.isEdit ? 'update' : 'create';
        const data = mergeRight(this.model, {
          shops: this.shops,
          start: tzUTC(this.start, '00:00:01'),
          end: tzUTC(this.end, '23:59:59'),
        });

        const id = this.model.id || null;

        this.wrapProgress(() =>
          this.$store
            .dispatch(
              `rewardTemplate/${action}`,
              {
                id,
                data,
              },
              { root: true },
            )
            .then(() => this.$router.push({ name: 'rewardTemplates' }))
            .catch(this.setError),
        );
      }
    },
  },
};
</script>
